






	// @ts-ignore
    import _ from './CListItemDetailHeaderTitle.ts'; export default _;
